import React, { useCallback } from 'react';
import { Tabs } from '@shopify/polaris';

const TabComponent = ({ children, tabs, selected, setSelected }) => {

    const handleTabChange = useCallback(
        (selectedTabIndex) => setSelected(selectedTabIndex),
        [],
    );

    return (
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
            {children}
        </Tabs>
    );
}

export default TabComponent;